export class BrowserStorage {
  /**
   * Stores data in the sessionStorage of the Browser
   */
  public static store(namespace: string, data?: object | string | number) {
    if (window.GLOBAL) {
      namespace += window.GLOBAL.ROUTER_BASE;
    }

    if (data !== void 0) {
      return sessionStorage.setItem(namespace, JSON.stringify(data));
    }

    const store = sessionStorage.getItem(namespace);
    return (store && JSON.parse(store)) || void 0;
  }

  public static removeStored(namespace: string) {
    if (window.GLOBAL) {
      namespace += window.GLOBAL.ROUTER_BASE;
    }
    return sessionStorage.removeItem(namespace);
  }

  public static storeNumber(namespace: string, data?: number) {
    if (data !== void 0) {
      return BrowserStorage.store(namespace, data as unknown as string);
    }
    const val = BrowserStorage.store(namespace);
    return (val && parseInt(val, 10)) || void 0;
  }

  /**
   * Stores data in the localStorage of the Browser
   *
   * Get: Only use namespace
   * Set: Pass namespace and data
   * Delete: Pass namespace and null
   */
  public static storePermanent(namespace: string, data?: object | string | number | null) {
    let actualNamespace = namespace;
    if (window.GLOBAL) {
      if (window.GLOBAL.ROUTER_BASE) {
        actualNamespace += window.GLOBAL.ROUTER_BASE;
      }
    }

    if (data) {
      return localStorage.setItem(actualNamespace, JSON.stringify(data));
    }

    if (data === null) {
      console.log("removing item", actualNamespace);
      return localStorage.removeItem(actualNamespace);
    }

    const store = localStorage.getItem(actualNamespace);
    return (store && JSON.parse(store)) || void 0;
  }

  public static getPermanent(namespace: string) {
    let actualNamespace = namespace;
    if (window.GLOBAL) {
      if (window.GLOBAL.ROUTER_BASE) {
        actualNamespace += window.GLOBAL.ROUTER_BASE;
      }
    }
    return JSON.parse(localStorage.getItem(actualNamespace));
  }

  public static get(namespace: string) {
    let actualNamespace = namespace;
    if (window.GLOBAL) {
      if (window.GLOBAL.ROUTER_BASE) {
        actualNamespace += window.GLOBAL.ROUTER_BASE;
      }
    }
    return JSON.parse(sessionStorage.getItem(actualNamespace));
  }
}
